<template>
  <div
    v-if="deleteConfirmationOpen"
    class="
      tw-flex tw-gap-2 tw-h-8 tw-py-0 tw-px-1
      -tw-my-1
      tw-bg-sf-neutral-lighter-1 tw-rounded-lg tw-items-center
    "
  >
    <SfButtonInverted
      variant="danger"
      class="tw-px-2 tw-text-xs tw-h-6"
      :disabled="changesAreDisabled"
      @click="emit('deleteAttachment')"
    >
      <i class="fa fa-trash !tw-text-[10px]"></i>
      {{ I18n.t('common.remove') }}
    </SfButtonInverted>

    <SfButtonInverted
      variant="dark"
      class="tw-h-6 tw-px-2 tw-text-xs"
      :disabled="changesAreDisabled"
      @click="closeDeleteConfirmation"
    >
      {{ I18n.t('common.cancel') }}
    </SfButtonInverted>
  </div>

  <a
    v-if="!deleteConfirmationOpen"
    class="
      sf-btn sf-btn-text
      tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center
      !tw-text-[10px]
      tw-text-sf-gray-dark
    "
    data-behaviour="document-download-link"
    :data-document-id="attachment.document_id"
  >
    <i class="fa fa-download"></i>
  </a>
  <a
    v-if="!deleteConfirmationOpen"
    class="
      sf-btn sf-btn-text
      tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center
      !tw-text-[10px]
      tw-text-sf-gray-dark
    "
    data-behaviour="document-preview-link"
    :data-document-id="attachment.document_id"
  >
    <i class="fa fa-external-link-alt"></i>
  </a>
  <SfButtonText
    v-if="!deleteConfirmationOpen"
    class="tw-w-6 tw-h-6 !tw-text-[10px] hover:tw-text-sf-danger"
    variant=""
    @click="openDeleteConfirmation"
  >
    <i class="fa fa-trash"></i>
  </SfButtonText>
</template>

<script setup lang="ts">
import { Attachment } from './types'
import { ref } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

import { SfButtonText } from '@app/shared/vue/components/sf-button'
import { SfButtonInverted } from '@app/shared/vue/components/sf-button'

const I18n = useI18n()

interface Props {
  attachment: Attachment
  changesAreDisabled: boolean
}

defineProps<Props>()

const emit =
  defineEmits<{
    deleteAttachment: []
  }>()

const deleteConfirmationOpen = ref(false)

function openDeleteConfirmation() {
  deleteConfirmationOpen.value = true
}

function closeDeleteConfirmation() {
  deleteConfirmationOpen.value = false
}
</script>
